var _excluded = ["style", "className", "onChange", "error"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import Textarea from '@adsk/alloy-react-textarea';
import { stylePropType } from '@adsk/alloy-react-theme';
var CommentInput = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var style = _ref.style,
    className = _ref.className,
    _onChange = _ref.onChange,
    error = _ref.error,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Textarea, _extends({
    ref: ref,
    style: style,
    className: className,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    error: !!error
  }, props));
});
CommentInput.displayName = 'CommentInput';
CommentInput.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /* The comment text */
  value: PropTypes.string.isRequired,
  /* Triggers on input change */
  onChange: PropTypes.func.isRequired,
  /* Triggers on input focus */
  onFocus: PropTypes.func.isRequired,
  /* Triggers on input blur */
  onBlur: PropTypes.func.isRequired,
  /* Is input in error state */
  error: PropTypes.string
};
export default CommentInput;
//# sourceMappingURL=CommentInput.js.map